import travelerImg1 from "../assets/images/home/whoweare.jpeg";
import { useNavigate } from "react-router-dom";

function WhoWeAreSection() {
  const navigate = useNavigate();

  return (
    <div className="who-section">
      <div className="container who-wrapper">

        {/* LEFT CONTENT */}
        <div className="who-content">
          <h2 className="who-title">Who We Are</h2>

          <p>
            We are a passionate travel company dedicated to crafting curated travel experiences across India. 
            Our focus is on blending adventure, spirituality, and nature into every journey while ensuring comfort, 
            safety, and seamless planning.
          </p>

          <p>
            Whether it’s a peaceful temple visit, an exciting jungle safari, or a fun group trip, Gypsy Companion 
            helps you explore India in a deeper and more enriching way.
          </p>

          <button 
            className="who-btn"
            onClick={() => navigate("/about")}
          >
            Explore More
          </button>
        </div>

        {/* RIGHT IMAGE */}
        <div className="who-image">
          <img src={travelerImg1} alt="Gypsy Companion travel experiences" />
        </div>

      </div>
    </div>
  );
}

export default WhoWeAreSection;